import React, { useEffect } from "react";
import "../pages/Service.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "boxicons/css/boxicons.min.css";

const servicesData = [
  { 
    icon: "bx bx-brain", 
    title: "AI/ML", 
    desc: "I specialize in developing AI-powered systems designed to address real-world challenges. My expertise includes data preprocessing, model architecture design, training, and deployment." 
  },
  { 
    icon: "bx bx-code-alt", 
    title: "Web Development", 
    desc: "Building responsive, fast, and user-friendly web applications using React, HTML, CSS, and JavaScript. Clean design, smooth interactions, scalable solutions." 
  },
  { 
    icon: "bx bx-bulb", 
    title: "Creative Problem Solving", 
    desc: "Combining technical skills with creativity to transform ideas into digital products. Prototyping, experimenting, and delivering innovative solutions." 
  }
];

export default function Service() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section id="services" className="services">
      <h2 className="heading" data-aos="fade-up">Services</h2>
      <div className="services-container">
        {servicesData.map((service, index) => (
          <div 
            className="service-box" 
            key={index} 
            data-aos="fade-up" 
            data-aos-delay={index * 200} 
            data-aos-once="true"
          >
            <div className="service-info">
              <i className={service.icon}></i>
              <h4>{service.title}</h4>
              <p>{service.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
